/**
 * Marigold Haveli Journey — warm daytime haveli plot-plane wedding journey.
 * Registered under id `marigold-haveli-journey`.
 */
import React from 'react';
import { registry } from '../registry';
import type { InvitationData, TemplateMetadata } from '../types';
import { PlotPlaneWeddingExperience } from '@/src/modules/experiences/wedding/plotPlane/PlotPlaneWeddingExperience';
import { marigoldHaveliJourneyTheme } from './theme';

const META: TemplateMetadata = {
  id: 'marigold-haveli-journey',
  name: 'Marigold Haveli Journey',
  occasionType: 'WEDDING',
  description:
    'A sun-washed haveli plot-plane journey: jali gate, courtyard hero, mandap room, function verandah chips, and RSVP courtyard — distinct daytime marigold craft, not a palette swap.',
  isPremium: true,
  tags: ['wedding', 'haveli', 'marigold', 'daytime', 'plot-plane', 'premium', 'interactive'],
  colorScheme: {
    primary: '#ea580c',
    accent: '#0d9488',
    bg: '#fff9f0',
  },
};

export function MarigoldHaveliJourney({ data }: { data: InvitationData }) {
  return <PlotPlaneWeddingExperience data={data} theme={marigoldHaveliJourneyTheme} />;
}

registry.register({ metadata: META, component: MarigoldHaveliJourney });
